import { VendorGetServerSideProps } from 'vendor/utils/VendorGetServerSideProps';
import { EventPageTemplate } from 'src/modules/events/templates/EventPageTemplate';
import { route } from 'src/services/route';
import { QueryKey } from 'src/models/query';
import { configureSSR } from 'src/utils/configureSSR';
import { fetchEventDetails } from 'src/modules/events/hooks/useEventDetailsQuery';
import { fetchSitemapEvents } from 'src/modules/events/hooks/useEventsSitemapQuery';

export const getServerSideProps = VendorGetServerSideProps(async (ctx) => {
  const slug = ctx.params?.slug;

  if (typeof slug !== 'string') {
    return {
      redirect: {
        destination: '/events/upcoming',
        permanent: false,
      },
    };
  }

  const event = await fetchEventDetails(ctx.apis, slug);

  if (!event) {
    return {
      notFound: true,
    };
  }

  return configureSSR(ctx, {
    layout: {
      variant: 'default',
      tvbar: false,
    },
    cacheControl: {
      maxAge: 600,
      sMaxAge: 1200,
    },
    actions: {
      common: () => [
        ctx.queryClient.setQueryData([...QueryKey.EventPage, slug], event),
      ],
    },
    return: {
      props: {
        slug,
      },
    },
  });
});

export async function getSitemap(): Promise<SitemapEntry[]> {
  const events = await fetchSitemapEvents();

  return events.map((event) => ({
    loc: route.event(event).page(),
    lastmod: event.date_updated ?? event.date_created,
    priority: 0.8,
  }));
}

export default EventPageTemplate;
